import { useState } from 'react';
import { IconJD } from './atoms';
import { ThemeToggle } from './ThemeToggle';
import { useAuth } from '../../auth/AuthContext';
import { currentUserEmail } from '../../auth/cognito';

export type DesktopTab = 'talk' | 'notes';
export type ContextTrack = 'all' | 'work' | 'home';

const TRACKS: ContextTrack[] = ['all', 'work', 'home'];

export function DesktopTopBar({
  tab,
  onTab,
  track,
  onTrack,
  onOpenNudges,
  onOpenSettings,
}: {
  tab: DesktopTab;
  onTab: (t: DesktopTab) => void;
  track: ContextTrack;
  onTrack: (t: ContextTrack) => void;
  onOpenNudges: () => void;
  onOpenSettings: () => void;
}) {
  const { signOut } = useAuth();
  const email = currentUserEmail();
  const initial = email ? email[0].toUpperCase() : 'J';
  const [accountOpen, setAccountOpen] = useState(false);

  return (
    <header className="jd-topbar">
      <span className="jd-wm">
        Jotly<span className="jd-wm-dot">.</span>
      </span>

      <div className="jd-ctx">
        {TRACKS.map((t) => (
          <button
            key={t}
            type="button"
            className={`jd-ctx-btn ${track === t ? 'active' : ''}`}
            onClick={() => onTrack(t)}
          >
            {t[0].toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      <div className="jd-topbar-spacer" />

      <nav className="jd-nav">
        <button
          type="button"
          className={`jd-nav-tab ${tab === 'talk' ? 'active' : ''}`}
          onClick={() => onTab('talk')}
        >
          Talk
        </button>
        <button
          type="button"
          className={`jd-nav-tab ${tab === 'notes' ? 'active' : ''}`}
          onClick={() => onTab('notes')}
        >
          Notes
        </button>
      </nav>

      <button
        type="button"
        className="jd-icon-btn"
        onClick={onOpenNudges}
        title="Notifications"
      >
        <IconJD name="bell" size={17} color="currentColor" stroke={1.7} />
      </button>

      <ThemeToggle />

      <button
        type="button"
        className="jd-icon-btn"
        onClick={onOpenSettings}
        title="Settings"
      >
        <IconJD name="settings" size={17} color="currentColor" stroke={1.7} />
      </button>

      <div className="jd-account">
        <button
          type="button"
          className="jd-topbar-avatar"
          title="Account"
          aria-haspopup="menu"
          aria-expanded={accountOpen}
          onClick={() => setAccountOpen((o) => !o)}
        >
          {initial}
        </button>

        {accountOpen && (
          <>
            <div
              className="jd-account-scrim"
              onClick={() => setAccountOpen(false)}
            />
            <div className="jd-account-pop" role="menu">
              <div className="jd-account-email" title={email ?? undefined}>
                {email ?? 'Signed in'}
              </div>
              <button
                type="button"
                className="jd-account-action"
                role="menuitem"
                onClick={signOut}
              >
                Sign out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
